import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../utils/axiosAuth";

// جلب إعدادات المستخدم
export const fetchUserLoyaltyCardsSettings = createAsyncThunk(
  "loyaltyCardsUserSettings/fetchUserSettings",
  async (userId, thunkAPI) => {
    try {
      const response = await api.get(
        `/api/users/${userId}/loyalty-cards-settings`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch error");
    }
  }
);

// حفظ إعدادات المستخدم
export const saveUserLoyaltyCardsSettings = createAsyncThunk(
  "loyaltyCardsUserSettings/saveUserSettings",
  async (params, thunkAPI) => {
    const { userId, settings } = params;
    try {
      const response = await api.post(
        `/api/users/${userId}/loyalty-cards-settings/update`,
        settings
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Save error");
    }
  }
);

// جلب الأعمدة المتاحة
export const fetchAvailableColumns = createAsyncThunk(
  "loyaltyCardsUserSettings/fetchAvailableColumns",
  async (_, thunkAPI) => {
    try {
      const response = await api.get(
        "/api/loyalty-cards-settings/available-columns"
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch error");
    }
  }
);

const loyaltyCardsUserSettingsSlice = createSlice({
  name: "loyaltyCardsUserSettings",
  initialState: {
    userSettings: null,
    availableColumns: [],
    defaultVisibleColumns: [],
    defaultColumnOrder: [],
    status: "idle",
    error: null,
  },
  reducers: {
    clearUserSettings: (state) => {
      state.userSettings = null;
    },
    updateLocalSettings: (state, action) => {
      if (state.userSettings) {
        state.userSettings = { ...state.userSettings, ...action.payload };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch user settings
      .addCase(fetchUserLoyaltyCardsSettings.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUserLoyaltyCardsSettings.fulfilled, (state, action) => {
        state.userSettings = action.payload;
        state.status = "succeeded";
      })
      .addCase(fetchUserLoyaltyCardsSettings.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Save user settings
      .addCase(saveUserLoyaltyCardsSettings.pending, (state) => {
        state.status = "loading";
      })
      .addCase(saveUserLoyaltyCardsSettings.fulfilled, (state, action) => {
        state.userSettings = action.payload;
        state.status = "succeeded";
      })
      .addCase(saveUserLoyaltyCardsSettings.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Fetch available columns
      .addCase(fetchAvailableColumns.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAvailableColumns.fulfilled, (state, action) => {
        state.availableColumns = action.payload.available_columns;
        state.defaultVisibleColumns = action.payload.default_visible_columns;
        state.defaultColumnOrder = action.payload.default_column_order;
        state.status = "succeeded";
      })
      .addCase(fetchAvailableColumns.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearUserSettings, updateLocalSettings } =
  loyaltyCardsUserSettingsSlice.actions;

// Selectors
export const selectUserLoyaltyCardsSettings = (state) =>
  state.loyaltyCardsUserSettings.userSettings;
export const selectAvailableColumns = (state) =>
  state.loyaltyCardsUserSettings.availableColumns;
export const selectDefaultVisibleColumns = (state) =>
  state.loyaltyCardsUserSettings.defaultVisibleColumns;
export const selectDefaultColumnOrder = (state) =>
  state.loyaltyCardsUserSettings.defaultColumnOrder;
export const selectLoyaltyCardsUserSettingsStatus = (state) =>
  state.loyaltyCardsUserSettings.status;
export const selectLoyaltyCardsUserSettingsError = (state) =>
  state.loyaltyCardsUserSettings.error;

export default loyaltyCardsUserSettingsSlice.reducer;
